"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_dom_1 = __importDefault(require("react-dom"));
const recoil_1 = require("recoil");
const react_query_1 = require("@tanstack/react-query");
require("@@/assets/i18n");
const components_1 = require("@/common/components");
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
const _1 = require(".");
const queryClient = new react_query_1.QueryClient();
const RoomMain = () => {
    const [isMax768Initial, setIsMax768Initial] = (0, react_1.useState)(true);
    (0, react_1.useEffect)(() => {
        if (window.innerWidth > 768) {
            setIsMax768Initial(false);
        }
    }, []);
    const [showMainFooter, setShowMainFooter] = (0, react_1.useState)(false);
    const maxWidth768 = (0, useMediaQuery_1.default)('(max-width:768px)');
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(components_1.NavHeader, { isMain: true, needBlockFilter: isMax768Initial ? false : true }), (0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
                    display: 'flex',
                    flexDirection: 'column',
                    rowGap: maxWidth768 ? '40px' : '50px',
                    paddingTop: maxWidth768 ? 0 : '40px',
                } }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
                            display: maxWidth768 ? 'flex' : 'grid',
                            flexDirection: 'column',
                            gridTemplateColumns: isMax768Initial ? 'auto' : 'auto 284px',
                            gap: '30px 40px',
                        } }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    rowGap: '20px',
                                    minWidth: 0, // ? https://stackoverflow.com/questions/61373563/swiper-nested-inside-displaygrid-css
                                } }, { children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(_1.MainBanner, {}), (0, jsx_runtime_1.jsx)(_1.MainFonds, {})] }), !isMax768Initial && (0, jsx_runtime_1.jsx)(_1.MainHotLike, {})] })), !isMax768Initial && (0, jsx_runtime_1.jsx)(_1.MainHotCommission, {})] })), (0, jsx_runtime_1.jsx)(react_query_1.QueryClientProvider, Object.assign({ client: queryClient }, { children: (0, jsx_runtime_1.jsx)(_1.MainRooms, { setShowMainFooter: setShowMainFooter }) }))] })), showMainFooter && (0, jsx_runtime_1.jsx)(_1.MainFooter, {}), (0, jsx_runtime_1.jsx)(components_1.BackToTop, {}), (0, jsx_runtime_1.jsx)(components_1.MobileTabBar, {})] }));
};
const domContainer = document.querySelector('#root');
react_dom_1.default.render((0, jsx_runtime_1.jsx)(recoil_1.RecoilRoot, { children: (0, jsx_runtime_1.jsx)(react_1.Suspense, Object.assign({ fallback: null }, { children: (0, jsx_runtime_1.jsx)(components_1.MainTheme, { children: (0, jsx_runtime_1.jsx)(RoomMain, {}) }) })) }), domContainer);
